export interface CoachLeaderEvidenceSummaryInput {
  transcriptDates: Array<string | null | undefined>;
  reflectionDates: Array<string | null | undefined>;
  artifactDates: Array<string | null | undefined>;
  lastSeenAt: string | null;
  latestEvidenceAt: string | null;
}

export interface CoachLeaderEvidenceSummaryViewModel {
  newCounts: {
    transcripts: number;
    reflections: number;
    artifacts: number;
    total: number;
  };
  snapshot: {
    transcriptCount: number;
    reflectionCount: number;
    artifactCount: number;
    lastActivityAt: string | null;
  };
}

function countItemsSince(items: Array<string | null | undefined>, lastSeenAt: string | null) {
  const lastSeenTs = lastSeenAt ? new Date(lastSeenAt).getTime() : 0;
  return items.filter((value) => {
    if (!value) return false;
    const ts = new Date(value).getTime();
    return !Number.isNaN(ts) && ts > lastSeenTs;
  }).length;
}

export function buildCoachLeaderEvidenceSummary(params: CoachLeaderEvidenceSummaryInput): CoachLeaderEvidenceSummaryViewModel {
  const transcriptCount = params.transcriptDates.filter(Boolean).length;
  const reflectionCount = params.reflectionDates.filter(Boolean).length;
  const artifactCount = params.artifactDates.filter(Boolean).length;

  const newCounts = {
    transcripts: countItemsSince(params.transcriptDates, params.lastSeenAt),
    reflections: countItemsSince(params.reflectionDates, params.lastSeenAt),
    artifacts: countItemsSince(params.artifactDates, params.lastSeenAt),
    total: 0,
  };
  newCounts.total = newCounts.transcripts + newCounts.reflections + newCounts.artifacts;

  return {
    newCounts,
    snapshot: {
      transcriptCount,
      reflectionCount,
      artifactCount,
      lastActivityAt: params.latestEvidenceAt,
    },
  };
}
